import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, X } from "lucide-react";
import { api } from "@/lib/api";

const KEY = "isoldit_launch_banner_dismissed";

export function LaunchBanner({ region }) {
  const [until, setUntil] = useState(null);
  const [hidden, setHidden] = useState(() => localStorage.getItem(KEY) === "1");
  useEffect(() => { api.get("/states").then((r) => setUntil(r.data.promo_until)); }, []);

  if (hidden || !until || new Date(until) < new Date() || !["QLD", "ALL"].includes(region)) return null;
  const close = () => { localStorage.setItem(KEY, "1"); setHidden(true); };

  return (
    <div data-testid="launch-banner" className="rise relative overflow-hidden rounded-2xl bg-[#d4f253] p-5 pr-12 text-[#0f2a33] sm:p-6 sm:pr-14">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
        <Sparkles className="h-9 w-9 shrink-0" />
        <div className="flex-1">
          <p className="font-display text-xl font-extrabold tracking-tight">We're now live in Queensland!</p>
          <p className="text-sm font-medium text-[#0f2a33]/80">It's launch week — be one of the first locals to list. Selling is free in 3 easy steps, and buyers pay you at pick-up.</p>
        </div>
        <Link to="/sell" data-testid="launch-banner-sell-btn" className="inline-flex shrink-0 items-center justify-center rounded-xl bg-[#0f2a33] px-5 py-3 text-sm font-bold uppercase tracking-wide text-[#d4f253] transition-transform hover:-translate-y-0.5">Sell free now</Link>
      </div>
      <button data-testid="launch-banner-close" onClick={close} aria-label="Dismiss" className="absolute right-3 top-3 rounded-full p-1.5 hover:bg-[#0f2a33]/10"><X className="h-4 w-4" /></button>
    </div>
  );
}
